import { createApp, watch } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { createHead, useHead } from "@vueuse/head";
import { createI18nInstance } from "./i18n";

// Global styles
import "./styles/base.css";
import "@fortawesome/fontawesome-free/css/all.css";

// App setup function that initializes everything
const initApp = async () => {
  const i18n = await createI18nInstance();

  const head = createHead();
  const app = createApp(App);

  app.use(router);
  app.use(store);
  app.use(i18n);
  app.use(head);

  // Global default meta fallback
  useHead({
    title: i18n.global.t("meta.default.title"),
    meta: [
      {
        name: "description",
        content: i18n.global.t("meta.default.description"),
      },
      { property: "og:title", content: i18n.global.t("meta.default.title") },
      {
        property: "og:description",
        content: i18n.global.t("meta.default.description"),
      },
      {
        property: "og:image",
        content: "https://biglosolutions.com/images/biglo_logo.png",
      },
      { property: "og:url", content: "https://biglosolutions.com" },
      { name: "twitter:title", content: i18n.global.t("meta.default.title") },
      {
        name: "twitter:description",
        content: i18n.global.t("meta.default.description"),
      },
      {
        name: "twitter:image",
        content: "https://biglosolutions.com/images/biglo_logo.png",
      },
      { name: "twitter:url", content: "https://biglosolutions.com" },
    ],
  });

  app.mount("#app");

  // Sync <html lang="">
  watch(
    () => i18n.global.locale.value,
    (lang) => {
      document.documentElement.setAttribute("lang", lang);
      localStorage.setItem("user-locale", lang);
    },
    { immediate: true },
  );
};

initApp();
